import { useIsMobile } from '@/hooks/use-mobile';
import { isWebBrowser } from '@/utils/deviceUtils';

/**
 * Returns true when the section "View All" / "See More" action should render
 * as a compact icon-only control (arrow) instead of a full button with label.
 * Used for mobile and native app to save space.
 * @returns {boolean}
 */
export function useCompactViewAll() {
  const isMobile = useIsMobile();
  const isNativeApp = !isWebBrowser();
  return isMobile || isNativeApp;
}
